import Glide from '@glidejs/glide'
import YoutubePlayer from "../../Molecule/YouTubePlayer/YouTubePlayer";

export default class YoutubeSlider {
    static init() {
        Array.prototype.forEach.call(document.querySelectorAll('.youtube-slider'), el => {
            new YoutubeSlider(el)
        });
    }

    static classes = {
        node: 'youtube-slider',
        slider: {
            slide: 'glide__slide',
            image: 'youtube-slider__image-slider',
            content: 'youtube-slider__content-slider'
        },
        bullet: {
            node: 'youtube-slider__bullet',
            active: 'youtube-slider__bullet--active'
        },
        player: {
            inner: 'youtube-player__inner'
        }
    }

    constructor(el) {
        if (!el) return;
        this.el = el;
        this.imageSliderElement = this.el.querySelector(`.${YoutubeSlider.classes.slider.image}`);
        this.contentSliderElement = this.el.querySelector(`.${YoutubeSlider.classes.slider.content}`);
        this.bulletElements = this.el.querySelectorAll(`.${YoutubeSlider.classes.bullet.node}`);
        this.bulletElementsArray = Array.from(this.bulletElements);
        this.currentBulletElement = this.el.querySelector(`.${YoutubeSlider.classes.bullet.active}`);
        this.isMobile = window.innerWidth < 1024;
        this.imageSliderOptions = {
            gap: 0,
            rewind: false
        };
        this.contentSliderOptions = {
            gap: 0,
            rewind: false,
            throttle: this.isMobile ? 25 : 1,
            animationDuration: this.isMobile ? 300 : 0,
            swipeThreshold: this.isMobile ? 80 : false,
            dragThreshold: this.isMobile ? 120 : false
        };

        this.imageSlider = new Glide(this.imageSliderElement, this.imageSliderOptions);
        this.contentSlider = new Glide(this.contentSliderElement, this.contentSliderOptions)


        this.imageSlider.mount()
        this.contentSlider.mount()

        // make first slide video active
        this.currentPlayer = YoutubePlayer.getPlayerById(this.getCurrentSlideVideoId());

        this.contentSlider.on('run', () => {
            // synchronize sliders
            this.imageSlider.go('=' + this.contentSlider.index);
        });

        this.imageSlider.on(['run'], () => {
            // synchronize sliders
            this.contentSlider.go('=' + this.imageSlider.index);

            // mark bullet as active
            let el = this.bulletElementsArray[this.imageSlider.index];
            this.currentBulletElement.classList.remove(YoutubeSlider.classes.bullet.active);
            el.classList.add(YoutubeSlider.classes.bullet.active);
            this.currentBulletElement = el;

            // update video state
            this.currentPlayer = YoutubePlayer.getPlayerById(this.getCurrentSlideVideoId());
            YoutubePlayer.playersList.map(player => {
                if (player.getState() === 'playing' || player.getState() === 'buffering' || player.getState() === 'cued') {
                    player.YTPause();
                }
            });

            let isNeosBackend = document.body.classList.contains('neos-backend');
            if(!isNeosBackend && !this.isMobile) {
                this.currentPlayer.startPlayerOnReady();
            }
        });

        // move slides on bullet click
        this.bulletElementsArray.forEach(el => {
            el.addEventListener('click', () => {
                if (this.currentBulletElement.isSameNode(el)) {
                    this.currentPlayer.startPlayerOnReady();
                } else {
                    this.imageSlider.go(el.dataset.glideDir);
                }
            });
        });
    }

    getCurrentSlideVideoId() {
        let currentSlide = Array.from(this.imageSliderElement.querySelectorAll(`.${YoutubeSlider.classes.slider.slide}`))[this.imageSlider.index]
        let playerInner = currentSlide.querySelector(`.${YoutubeSlider.classes.player.inner}`);
        return playerInner ? playerInner.dataset.id : null;
    }
}
